<div class="upsell-wait p-4">
  <div class="upsell-wait__container max-w-container mx-auto flex items-center gap-4 desktop:gap-8">
    @if (iconWait) {
      <img class="upsell-wait__icon w-16 desktop:w-20 shrink-0" [src]="iconWait" alt="">
    }
    <div class="upsell-wait__text">
      <h1 class="upsell-wait__title text-h1-alt-mobile desktop:text-h1-alt font-bold uppercase text-dmp-green m-0" [innerHTML]="title"></h1>
      @if (description) {
        <div class="upsell-wait__description mt-4" [innerHTML]="description"></div>
      }
    </div>
  </div>
</div>
